module.exports = __webpack_public_path__ + "c89387dd53174451f3d7e793418763e5.svg";